import { getBucketFileIdsFromContent } from '../../utils/tiptap/getBucketFileIdsFromContent.mjs'
import { getNoteContentAsJson } from './getNoteContentAsJson.mjs'

export function getImageBucketFileIdsFromNoteContents(note) {
  if (!note || !note.yDoc) return false
  return getBucketFileIdsFromContent(getNoteContentAsJson(note))
}
